import React from 'react';
import { CRITERIOS } from '../utils/tournamentFormats';

// Editor de la cadena de desempate: una lista ORDENADA de criterios. La tabla se ordena por el
// primero; si empatan, por el segundo, y así. Lo que sobrevive a toda la cadena lo ordena el juez.
//
// `value` null = "el orden de siempre" (puntos primero y después el desempate clásico): es lo que
// tienen los torneos viejos y la liga, y no se toca salvo que alguien elija una cadena.
export default function RankChainEditor({ value, onChange, disabled }) {
    const lista = Array.isArray(value) ? value : null;

    if (!lista) {
        return (
            <div>
                <div style={{ fontSize: 13, marginBottom: 6 }}>
                    Orden de siempre: <strong>puntos</strong>, y a igualdad, victorias y puntaje del juego.
                </div>
                <button type="button" className="btn btn-sm btn-white" disabled={disabled}
                    onClick={() => onChange(['points', 'wins', 'raw'])}>
                    Elegir la cadena a mano
                </button>
            </div>
        );
    }

    const mover = (i, d) => {
        const n = lista.slice();
        const j = i + d;
        if (j < 0 || j >= n.length) return;
        [n[i], n[j]] = [n[j], n[i]];
        onChange(n);
    };
    const quitar = (i) => {
        const n = lista.filter((_, k) => k !== i);
        onChange(n.length ? n : null);
    };
    const disponibles = Object.keys(CRITERIOS).filter((c) => !lista.includes(c));

    return (
        <div>
            <ol style={{ paddingLeft: 20, marginBottom: 8 }}>
                {lista.map((c, i) => (
                    <li key={c} style={{ fontSize: 13, marginBottom: 4 }}>
                        <span className="d-inline-flex align-items-center" style={{ gap: 6 }}>
                            <strong>{CRITERIOS[c].label}</strong>
                            <span className="text-muted" style={{ fontSize: 12 }}>— {CRITERIOS[c].ayuda}</span>
                            {disabled ? null : (
                                <span className="d-inline-flex" style={{ gap: 3 }}>
                                    <button type="button" className="btn btn-sm btn-white py-0 px-1" disabled={i === 0}
                                        onClick={() => mover(i, -1)} aria-label="Subir">↑</button>
                                    <button type="button" className="btn btn-sm btn-white py-0 px-1" disabled={i === lista.length - 1}
                                        onClick={() => mover(i, 1)} aria-label="Bajar">↓</button>
                                    <button type="button" className="btn btn-sm btn-white py-0 px-1"
                                        onClick={() => quitar(i)} aria-label="Quitar">✕</button>
                                </span>
                            )}
                        </span>
                    </li>
                ))}
                <li style={{ fontSize: 13, color: '#818EA3', listStyle: 'none', marginLeft: -20 }}>
                    y si sigue el empate: <strong>lo ordena el juez</strong>.
                </li>
            </ol>
            {disabled ? null : (
                <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                    {disponibles.length ? (
                        <select className="form-control form-control-sm" style={{ width: 'auto' }} value=""
                            onChange={(e) => e.target.value && onChange(lista.concat([e.target.value]))}>
                            <option value="">+ Agregar criterio…</option>
                            {disponibles.map((c) => <option key={c} value={c}>{CRITERIOS[c].label}</option>)}
                        </select>
                    ) : null}
                    <button type="button" className="btn btn-sm btn-link p-0" onClick={() => onChange(null)}>
                        Volver al orden de siempre
                    </button>
                </div>
            )}
        </div>
    );
}
